import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=66288470&scoped=true&"
import script from "./groupDetail.vue?vue&type=script&lang=js&"
export * from "./groupDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=66288470&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66288470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66288470')) {
      api.createRecord('66288470', component.options)
    } else {
      api.reload('66288470', component.options)
    }
    module.hot.accept("./groupDetail.vue?vue&type=template&id=66288470&scoped=true&", function () {
      api.rerender('66288470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/groupDetail.vue"
export default component.exports